import { Component, Output, EventEmitter } from "@angular/core";
import { ConsentService } from "src/app/_services/consent.service";

@Component({
  selector: 'instant-consent',
  templateUrl: './instant-consent.component.html',
})
export class InstantConsent {
    
  @Output() onAccept = new EventEmitter<void>();
  @Output() onDeny = new EventEmitter<void>();
  
  customizeSelection: boolean = false;
  
  constructor(
    private consentService: ConsentService
    ) {
  }

  accept() {
    this.consentService.grantConsent();
    this.onAccept.emit();
  }
  
  deny() {
    this.consentService.denyConsent();
    this.onDeny.emit();
  }
}
